<template>
  <div class="app-error-panel">
    <div class="ui-panel">
      <p class="app-error-panel__message">
        {{ $t('Something went wrong. Please, reload the application.') }}
      </p>

      <div class="app-error-panel__footer">
        <button
          class="ui-button ui-button--primary app-error-panel__button"
          type="button"
          @click="goBack"
        >
          {{ $t('Reload') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppErrorPage',

  methods: {
    goBack() {
      window.location.reload()
    },
  },
}
</script>

<style>
.app-error-panel {
  width: 95vw;
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  display: flex;
  align-items: center;
}

.app-error-panel__message {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 20px;
}

.app-error-panel__footer {
  padding-top: 15px;
  border-top: 1px solid #ddd;
  text-align: right;
}
</style>
